import React from 'react'
import { Breadcrumb } from '../../../types/cms'
import {Box, Stack, Text} from '../../../vanilla'
import { Breadcrumbs } from '../../breadcrumbs'

interface BreadCrumbsProps {
  breadCrumb: Breadcrumb[]
}

export const BreadcrumbsContent = ({breadCrumb}: BreadCrumbsProps) => {
    return <Stack>
        {breadCrumb && (
            <Box paddingY="12px">
                <Breadcrumbs
                breadcrumbs={breadCrumb.map(({crumbText, crumbCtaLink}) => ({
                    id: crumbText.toUpperCase(),
                    name: crumbText,
                    url: crumbCtaLink,
                }))}
                />
            </Box>
            )}
    </Stack>
}